import { Component } from '@theme/component';

/**
 * Brand header for meno-therapy.
 * Toggles the mobile nav drawer. Uses the theme's declarative `on:click="toggle"`.
 */
class HeaderMeno extends Component {
  toggle() {
    const { drawer, toggle } = this.refs;
    if (!drawer) return;
    const willOpen = drawer.hasAttribute('hidden');
    drawer.toggleAttribute('hidden', !willOpen);
    toggle?.setAttribute('aria-expanded', String(willOpen));
  }
}

if (!customElements.get('header-meno')) {
  customElements.define('header-meno', HeaderMeno);
}
